import logo from "./logo.svg";
import "./App.css";
import { useEffect, useState } from "react";

const API = "https://b27we-node.herokuapp.com";
// const API = 'http://localhost:4000'
function App() {
  const [recipeList, setRecipeList] = useState([]);

  useEffect(() => {
    fetch(`${API}/recipes`)
      .then((data) => data.json())
      .then((data) => setRecipeList(data));
  }, []);

  return (
    <div className="App recipe-list-container">
      {recipeList.map((recipe) => (
        <Recipe recipe={recipe} />
      ))}
    </div>
  );
}

function Recipe({ recipe }) {
  return (
    <div className="recipe-container">
      <img className="recipe-picture" src={recipe.picture} alt={recipe.name} />
      <p className="recipe-name">{recipe.name}</p>
    </div>
  );
}

export default App;
